const POLLING_INTERVAL = 12000;
export default POLLING_INTERVAL;
